module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/uWIsFI/images/cover.jpg?1684306110648",
      "alt": "This image is the cover for the book Historic Cape May, New Jersey"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Historic Cape May, New Jersey\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Cape May began as Cape May Island, where families journeyed to enjoy wide white beaches and gentle surf during the early nineteenth century. With the advent of steamships and railroads, the quiet village soon became America's first seaside resort town. Despite its charm and elegance, visitors slowed in the 1880s, as a series of mysterious fires claimed some of its most beloved structures. As the twentieth century dawned, Cape May's failure to modernize ultimately became its salvation. By the 1960s, visitors were once again flocking to this seaside destination to enjoy its quaint Victorian charm. Experience the elegant Chalfonte Hotel, stately Congress Hall and the classic Cape May Boardwalk with local historian Emil Salvini.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Emil R. Salvini\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Emil Salvini is a widely published and well-recognized New Jersey historian. He is a past President of the North Jersey Highlands Historical Society and lifetime member of Cape May County Historical Society.  He also produces a television show for New Jersey's PBS affiliate.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0